
import { ElementMixin } from "vue-slicksort";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { PrintGroup } from "@/models/PrintGroup";
import PrintBasketGroup from "@/components/PrintBasket/PrintBasketGroup/PrintBasketGroup.vue";

@Component({
  components: {
    PrintBasketGroup,
  },
})
// @ts-expect-error: https://github.com/Jexordexan/vue-slicksort/issues/143
export default class SortableGroupItem extends Mixins(ElementMixin) {
  @Prop()
  list!: PrintGroup;

  @Prop()
  index!: number;
}
